/**
 * 空チェック
 * (undefined,nullも空とみなす)
 *
 * @param str
 */
const isEmpty = (str) => {
  if (str === undefined || str === null || str === '') {
    return true
  } else {
    return false
  }
}

export default { isEmpty }
